<template>
    <div>
        <h1>Error 404, esta ruta no existe!!!</h1>
    </div>
</template>

<script>
export default {
    name:"errorView",

}
</script>

<style>

</style>